import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { isAfter } from 'date-fns';
import { UserContextService } from '@/app/shared/services/user-context/user-context.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, first, map } from 'rxjs';
import { EulaService } from '@/app/features/eula/services/eula.service';

export const eulaGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userContextService = inject(UserContextService);
  const eulaService = inject(EulaService);

  return combineLatest([
    toObservable(userContextService.userProfile),
    toObservable(userContextService.eulaUploadedAt),
    toObservable(eulaService.eulaAccepted),
  ]).pipe(
    first(([userProfile, uploadedAt, _]) => userProfile !== undefined && uploadedAt !== undefined),
    map(([userProfile, uploadedAt, eulaAccepted]) => {
      if (eulaAccepted) {
        return true;
      }
      if (userProfile?.eulaAcceptedAt && uploadedAt) {
        return isAfter(new Date(userProfile.eulaAcceptedAt), new Date(uploadedAt)) ? true : router.createUrlTree(['/eula']);
      }
      return router.createUrlTree(['/eula']);
    }),
  );
};
